import axios from 'axios';
import { getFirebaseAuth } from '../firebase/index';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

const client = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(async (config) => {
  const auth = await getFirebaseAuth();
  const user = auth.currentUser;
  
  if (user) {
    // Local Dev Bypass: Send test token + User ID header to avoid backend ADC requirement
    if (import.meta.env.DEV || window.location.hostname === 'localhost') {
       config.headers.Authorization = `Bearer test-token`;
       config.headers['X-User-ID'] = user.uid;
    } else {
       const token = await user.getIdToken();
       config.headers.Authorization = `Bearer ${token}`;
    }
  }
  
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default client;
